// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControlLabel,
  Switch,
  Divider,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
// import MDBadge from "theme/components/MDBadge";
// import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import AppConfig from "appConfig";
import Editor from "react-simple-wysiwyg";

function ChurnCampaignView() {
  const pageTitle = "Churn Campaign View";
  usePageTitle(pageTitle);
  const { id: reference } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [campaign, setCampaign] = useState({});
  const [totalCustomers, setTotalCustomers] = useState(0);

  const [openModifyDialog, setOpenModifyDialog] = useState(false);

  const [title, setTitle] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [subject, setSubject] = useState(null);
  const [messageBody, setMessageBody] = useState(null);
  const [textBody, setTextBody] = useState(null);
  const [channels, setChannels] = useState(null);
  const [showTextBody, setShowTextBody] = useState(true);
  const [isDiscountPercentage, setIsDiscountPercentage] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);

  useEffect(() => {
    if (channels == null) {
      return;
    }

    if (channels.toUpperCase().includes("SMS")) {
      setShowTextBody(true);
    } else {
      setShowTextBody(false);
    }
  }, [channels]);

  async function modifyCampaign() {
    if (title === null) {
      setSeverity("error");
      setErrMsg("Name is required.");
      setOpen(true);
      return;
    }

    setOpenModifyDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
      subject: `${subject}`,
      message_body: messageBody,
      text_body: textBody,
      channels: `${channels}`,
      is_discount_percentage: isDiscountPercentage,
      discount: !isDiscountPercentage ? parseFloat(discount) * 100 : parseFloat(discount) / 100,
    };

    await axios
      .post(`portal/churn_campaigns/${reference}/modify.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateStatus() {
    setShowLoading(true);
    await axios
      .get(`/portal/churn_campaigns/${reference}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/churn_campaigns/${reference}/get.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setTotalCustomers(result.data.data.total_customers);

            setTitle(result.data.data.campaign.title);
            setMessageBody(result.data.data.campaign.message_body);
            setTextBody(result.data.data.campaign.text_body);
            setSubject(result.data.data.campaign.subject);
            setChannels(result.data.data.campaign.channels);
            setDiscount(result.data.data.campaign.discount);
            setIsDiscountPercentage(result.data.data.campaign.is_discount_percentage);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  const [openUploadCustomersDialog, setOpenUploadCustomersDialog] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/churn_campaigns/customers/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadCustomers = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("campaign", reference);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadCustomersDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openModifyDialog}>
        <DialogTitle>
          <MDBox>Modify Campaign</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                value={title}
                placeholder="E.g Chicken Republic Deal"
                name="title"
                margin="dense"
                label="Campaign Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={subject}
                placeholder="Subject"
                name="subject"
                margin="dense"
                label="Message Subject"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setSubject(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Editor
                value={messageBody}
                onChange={(e) => setMessageBody(e.target.value)}
                placeholder="Message body"
              />
            </MDBox>
            <MDBox mt={1} p={1}>
              <MDTypography variant="h6" fontWeight="light" fontSize="small" color="warning">
                <Icon>info</Icon> &nbsp; You can customize your message or subject with the
                following variables: {"{{FIRST_NAME}}, {{LAST_NAME}}, {{CTA}}"}
              </MDTypography>
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={channels}
                placeholder="E.g EMAIL, SMS, WHATSAPP"
                name="channels"
                margin="dense"
                label="Message Channels (comma separated)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setChannels(e.target.value)}
              />
              <MDBox>
                <MDTypography variant="h6" fontWeight="light" fontSize="small" color="dark">
                  Supported: EMAIL, SMS and WHATSAPP
                </MDTypography>
              </MDBox>
            </MDBox>
            {showTextBody ? (
              <MDBox mt={3}>
                <MDInput
                  placeholder="Text Message"
                  name="dispenseCount"
                  margin="dense"
                  label="Text Message Body"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={textBody}
                  onChange={(e) => setTextBody(e.target.value)}
                />
              </MDBox>
            ) : (
              <> </>
            )}

            <MDBox mt={3}>
              <MDInput
                placeholder="Discount"
                name="dispenseCount"
                margin="dense"
                label="Discount"
                type="text"
                fullWidth
                variant="outlined"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
              />
            </MDBox>

            <MDBox mt={3}>
              <FormControlLabel
                control={
                  <Switch
                    color="success"
                    checked={isDiscountPercentage}
                    onChange={() => setIsDiscountPercentage(!isDiscountPercentage)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Is Discount Percentage?"
                labelPlacement="start"
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenModifyDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              modifyCampaign();
            }}
          >
            Modify
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadCustomersDialog}>
        <DialogTitle>
          <MDBox>Upload Customers</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2} pl={3} alignContents="center">
              <a
                href={`${AppConfig.api_media_url}documents/templates/customer_upload_template.csv`}
                target="_blank"
                rel="noreferrer"
              >
                == Sample Template ==
              </a>
            </MDBox>
            <Divider />
            <MDBox mt={2}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadCustomersDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadCustomers();
            }}
          >
            Upload Customers
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <MDBox>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={4} lg={4}>
                  <MDButton
                    variant="outlined"
                    color="warning"
                    onClick={() => {
                      navigate(`/churn-campaigns/${reference}/customers`);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>group</Icon>
                    &nbsp; View Customers
                  </MDButton>
                </Grid>
                <Grid item xs={6} md={4} lg={4} align="center">
                  <MDButton
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      navigate(`/churn-campaigns/${reference}/payments`);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>receipt</Icon>
                    &nbsp; View Payments
                  </MDButton>
                </Grid>
                <Grid item xs={6} md={4} lg={4} align="right">
                  <MDButton
                    variant="outlined"
                    color="info"
                    onClick={() => {
                      setUploadFile(null);
                      setOpenUploadCustomersDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                    &nbsp;Upload Customers
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox mb={5}>
                  <MDBox>
                    <MDBox
                      pt={2}
                      px={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <MDTypography variant="h6" fontWeight="medium">
                        Campaign Information
                      </MDTypography>
                      <MDBox>
                        <MDButton
                          variant="outlined"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setOpenModifyDialog(true);
                          }}
                          size="small"
                        >
                          <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                    {/* <Grid item xs={6} md={6} lg={6}>
                        <MDTypography variant="h6" fontWeight="light" align="right">
                          <a
                            href={`${AppConfig.api_base_url}campaigns/reports/${campaign.id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Icon sx={{ fontWeight: "bold" }}>download</Icon> &nbsp;Reports
                          </a>
                        </MDTypography>
                      </Grid> */}
                  </MDBox>
                  <MDBox mt={5}>
                    <TableContainer component={Paper}>
                      <Table aria-label="campaign information">
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Name
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.title}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Subject
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.subject}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Message Body
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                <div dangerouslySetInnerHTML={{ __html: campaign.message_body }} />
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Text Body
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.text_body}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Channels
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.channels}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Discount
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.is_discount_percentage
                                  ? `${campaign.discount * 100}%`
                                  : `N${(campaign.discount / 100).toFixed(2)}`}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Total Customers
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {totalCustomers}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Date Added
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {campaign.created}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Status
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDBox>
                                <Switch
                                  color={campaign.status ? "success" : "error"}
                                  checked={campaign.status}
                                  onChange={() => updateStatus()}
                                  // inputProps={{ "aria-label": "controlled" }}
                                />
                              </MDBox>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ChurnCampaignView;
